const temp = {}; export default temp;